/**
 * QUOTATION FILE UPLOADER — factory della callback `uploadFile` che
 * `useFileDropzone` si aspetta.
 *
 * Fissa `quotationId` e `type` a closure, dispatcha `uploadQuotationFile` e
 * ritorna `true` se la thunk è andata a buon fine. Serve a non far replicare la
 * stessa chiusura inline a ogni punto di caricamento: il dropzone ragiona a
 * batch di file, la thunk persiste un allegato per volta, e la conversione fra
 * i due sta scritta qui una volta sola.
 */

import type { AppDispatch } from '../../store/store';
import { uploadQuotationFile } from './quotationFileThunks';
import type { QuotationFileType } from './quotationFileMappers';

export function makeQuotationFileUploader(
  dispatch: AppDispatch,
  quotationId: number,
  type: QuotationFileType,
) {
  return async (file: File): Promise<boolean> => {
    const res = await dispatch(
      uploadQuotationFile({ quotationId, type, fileName: file.name, file }),
    );
    return uploadQuotationFile.fulfilled.match(res);
  };
}
